function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-265.5 -601.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(266 602)",
  fill: "none",
  stroke: "#25a4b4",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(228.039 478.701)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.694,172.96H68a1.707,1.707,0,0,1-1.7-1.7V155.3a1.706,1.706,0,0,1,1.7-1.7h6.966l2.825,2.7h10.9a1.707,1.707,0,0,1,1.7,1.7v13.259A1.707,1.707,0,0,1,88.694,172.96Z",
  transform: "translate(-10.018 -9.981)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.709,162.749H57.977a1.466,1.466,0,0,1-1.139-.526,1.488,1.488,0,0,1-.325-.974V145.9a2.717,2.717,0,0,1,.152-1.261,1.468,1.468,0,0,1,1.313-.8h6.962c-.065-.027-.127-.054-.193-.079q1.22,1.168,2.438,2.333c.127.122.25.247.38.363a.375.375,0,0,0,.279.095h10.35c.217,0,.445-.014.662.005a1.455,1.455,0,0,1,1.286,1.456v13.276a1.46,1.46,0,0,1-.3.9,1.423,1.423,0,0,1-1.131.559.271.271,0,0,0,0,.542,2,2,0,0,0,1.961-1.72,4.469,4.469,0,0,0,.019-.572V148a2.011,2.011,0,0,0-1.329-1.877,2.62,2.62,0,0,0-.917-.111H67.771c.065.027.127.054.193.079q-.98-.94-1.964-1.877c-.282-.271-.559-.548-.849-.811-.157-.141-.388-.1-.586-.1H58.392a4.8,4.8,0,0,0-.814.035,2.006,2.006,0,0,0-1.608,1.85c-.019.358,0,.721,0,1.082v15.042a2.006,2.006,0,0,0,1.5,1.92,4.885,4.885,0,0,0,1.161.06H78.7A.273.273,0,0,0,78.709,162.749Z",
  fill: "#25a4b4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(266 543.604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5,0A.5.5,0,0,1,1,.5v6a.5.5,0,0,1-1,0V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(30 86.396)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5,0A.5.5,0,0,1,1,.5v6a.5.5,0,0,1-1,0V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(34 89.396) rotate(90)",
  fill: "#fff"
})));

var SvgAddFolder = function SvgAddFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-folder.0c3b756d.svg";
export { ForwardRef as ReactComponent };